import api from '../../helpers/api';

export const getArtisanJobs = body =>
  api.post('job/search-jobs-for-profile', { ...body });

export const getArtisanPendingJobs = body =>
  api.post('job-staging/search-for-profile', { ...body });

export const createArtisanJob = formData =>
  api.post('job-staging', { ...formData });

export const putUpdateApplicantStatus = body =>
  api.put('job/update-status', { ...body });

export const updateArtisanJob = (id, formData) =>
  api.put(`job/${id}`, { ...formData });

export const deleteArtisanJob = (id, formData) =>
  api.delete(`job-staging/${id}`, { ...formData });

export const getSingleArtisanJob = id => api.get(`job/${id}`);
